export default __webpack_public_path__ + "static/404-error-img-a3896d7ed3ac8c2c6b1a2368b1855afa.png";